export default "__VITE_ASSET__ak0gp1VE__"